import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=74050d3e&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74050d3e')) {
      api.createRecord('74050d3e', component.options)
    } else {
      api.reload('74050d3e', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=74050d3e&", function () {
      api.rerender('74050d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2bybKoOlWb5/JS/comp/pricelist.vue"
export default component.exports